
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { ChatMessageVm } from '@/interfaces/AiCourseWizardVm';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

@Component
export default class AiChatModule extends Vue {
  @PropSync("chatMessages") syncedChatMessages!:  ChatMessageVm[];

  private newMessage: string = '';
  markdownEnabled: boolean = true;
  private isLoading: boolean = false;

  created() {
  }

  mounted() {
    // capture mode so Ctrl+Enter is caught even when textarea stops propagation
    window.addEventListener('keydown', this.onKeyDown as EventListener, true);
  }

  @Watch('syncedChatMessages')
  onChatMessagesChanged() {
    this.$nextTick(() => {
      this.$globalHelper.animateScrollToBottom("chatContent", 500);
    });
  }

  async sendMessage() {
    if (!this.newMessage.trim()) return;

    // add user message
    const userMessage: ChatMessageVm = {
      id: this.syncedChatMessages.length + 1,
      message: this.newMessage.trim(),
      fromAi: false
    };

    this.syncedChatMessages.push(userMessage);
    this.newMessage = '';
    this.$emit('newChatMessage', userMessage);
  }

  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeyDown as EventListener, true);
  }

  private onKeyDown(e: KeyboardEvent) {
    if (e.key === 'Enter' || e.key === 'Return') {
      if (e.shiftKey) {
        // Shift + Enter: Zeilenumbruch erlauben (Standard-Verhalten)
        return;
      }
      // Normales Enter: Nachricht senden
      e.preventDefault();
      this.sendMessage();
    }
  }

  // private renderMarkdown(text: string): string {
  //   // Markdown in HTML umwandeln und sichern gegen XSS
  //   const rawHtml = marked(text, { async: false }) as string;
  //   return DOMPurify.sanitize(rawHtml);
  // }

  private renderMarkdown(text: string): string {
    // Use Marked explicit synchron, to make sure to get a string and not a promise
    try {
      // for new marked versions (save way)
      const rawHtml = marked(text, { async: false }) as string;
      return DOMPurify.sanitize(rawHtml);
    } catch (error) {
      console.error('Fehler beim Parsen von Markdown:', error);
      return text; // Fallback to original text
    }
  }
}
